'use strict';

var UserManagementManageUsersDeleteModalDirective = function UserManagementManageUsersDeleteModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/user-management-manage-users-delete-modal.html'),
    controller: 'UserManagementManageUsersDeleteModalController',
    link: function link($scope, $element) {
      $scope.hideDeleteModal = function () {
        $element.modal('hide');
      };
    }
  };
};
UserManagementManageUsersDeleteModalDirective.$inject = [];
module.exports = UserManagementManageUsersDeleteModalDirective;